export const ACCEPTED_INVITATION_RETAILERS = 'ACCEPTED_INVITATION_RETAILERS';
export const ACCEPTED_INVITATION_RETAILERS_OFFSET = 'ACCEPTED_INVITATION_RETAILERS_OFFSET';
export const ACCEPTED_INVITATION_RETAILERS_ORDER = 'ACCEPTED_INVITATION_RETAILERS_ORDER';
export const ACCEPTED_INVITATION_RETAILERS_COUNT = 'ACCEPTED_INVITATION_RETAILERS_COUNT';
export const ACCEPTED_INVITATION_RETAILERS_LOADING = 'ACCEPTED_INVITATION_RETAILERS_LOADING';
